<template>
  <div class="quiz-info-section flex-col md:flex-row flex justify-between">
    <div class="quiz-info-head">
      <div class="flex gap-2">
        <div
          class="quiz-order
          flex gap-1 justify-between items-center font-bold bg-primary-50
          mb-5 text-xs rounded px-2 py-1"
        >
          <aha-icon
            :name="iconSlideType"
            height="16"
            width="16"
            viewBox="0 0 30 30"
            maintain-color
          ></aha-icon>
          {{ slideName }}
        </div>
      </div>
      <div v-if="slide.title" class="quiz-title" :data-order="order">
        {{ slide.title }}
      </div>
      <div class="flex gap-4">
        <TypeCorrectAnswer
          v-if="isShowTypeCorrectAnswer"
          :type-answer-correct="result.result"
        />
        <div v-if="answer?.timeAnswer" class="flex justify-between items-center">
          <strong>{{ answer?.timeAnswer | MMmSSs }}</strong>&nbsp;{{ $i18nPresenter.t('time') }}
        </div>
        <div v-if="answer?.point" class="flex justify-between items-center">
          <strong>{{ answer?.point || 0 | formatTotalPoint }}</strong>&nbsp;{{ $i18nPresenter.t('points') }}
        </div>
      </div>
      <div class="quiz-info-wrapper">
      </div>
    </div>
    <img
      v-if="slide.image"
      :src="slide.image.thumbnail"
      class="img w-full md:w-36 md:max-h-36 rounded"
    >
  </div>
</template>

<script>
import TypeCorrectAnswer from '@/components-v2/presentation-report/ReportAudienceDetail/TypeCorrectAnswer.vue'
import constants from '@/constant'

export default {
  components: {
    TypeCorrectAnswer,
  },
  props: {
    result: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      icons: {
        [constants.SLIDE_TYPE.POLL]: 'multiple-choice',
        [constants.SLIDE_TYPE.OPEN_ENDED]: 'open-ended',
        [constants.SLIDE_TYPE.IDEAS]: 'brainstorm',
        [constants.SLIDE_TYPE.QUESTION]: 'qa',
        [constants.SLIDE_TYPE.WORD_CLOUD]: 'word-cloud',
        [constants.SLIDE_TYPE.SCALE]: 'scales',
        [constants.SLIDE_TYPE.CORRECT_ORDER]: 'correct-order',
        [constants.SLIDE_TYPE.TYPE_ANSWER]: 'mti-type-answer',
        [constants.SLIDE_TYPE.MATCH_PAIRS]: 'match-pairs',
        [constants.SLIDE_TYPE.PICK_ANSWER]: 'pick-answer',
        [constants.SLIDE_TYPE.IMAGE_CHOICE]: 'pick-answer',
        [constants.SLIDE_TYPE.CATEGORISE]: 'categorise',
        [constants.INDIVIDUAL_REPORT_QUESTION_TYPE.WORD_CLOUD]: 'word-cloud',
        [constants.INDIVIDUAL_REPORT_QUESTION_TYPE.OPEN_ENDED]: 'open-ended',
      },
    }
  },
  computed: {
    slide() {
      return this.result?.slideDetails
    },
    answer() {
      return this.result?.Answer
    },
    slideName() {
      return constants.SLIDE_NAMES[this.slideType]
    },
    slideType() {
      return this.slide.slideType || this.slide.type
    },
    iconSlideType() {
      return this.icons[this.slideType] || 'multiple-choice'
    },
    isShowTypeCorrectAnswer() {
      if (this.isPollSlideVote) {
        return false
      }
      return this.result.result
    },
    isPollSlideVote() {
      return this.slideType === constants.SLIDE_TYPE.POLL && !this.slide.hasCorrectAnswer
    },
  },

}
</script>

<style lang="scss" scoped>
.quiz-info-section {
  margin-bottom: 12px;
}

.quiz-info-head {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.quiz-marker {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid var(--secondary-20, #D3D7E1);
  color: #313131;
  background: #FFF;
  transition: 0.2s all ease;

  @media screen and (min-width: 1280px) {
    &:hover, &:focus {
      color: #FFF;
      background: var(--primary-85, #4F9BF3);
    }
  }
}

.quiz-order {
  align-self: flex-start;
}

.quiz-title {
  position: relative;
  margin-bottom: 12px;
  color: var(--base-90, #313131);
  font-size: 16px;
  font-weight: bold;
  padding-left: 1rem; /* Space for the number */

  &::before {
    content: attr(data-order) "."; /* Use the data-number attribute */
    position: absolute;
    left: 0;
  }
}

.quiz-info-wrapper {
  display: grid;
  gap:12px;
  grid-template-columns: 1fr auto;

  .quiz-image {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
